module.exports = __webpack_public_path__ + "static/media/maptrails.3273eff6.png";